import { graphql, useStaticQuery } from 'gatsby';

interface SiteMetadataQuery {
  site: {
    siteMetadata: {
      title: string;
      description: string;
      keywords: Array<string>;
      siteUrl: string;
      imageUrl: string;
      language: string;
    };
  };
}

export const useSiteMetadata = () => {
  const {
    site: { siteMetadata },
  } = useStaticQuery<SiteMetadataQuery>(
    graphql`
      query {
        site {
          siteMetadata {
            title
            # Commented for now, it doesn't match sanity's schema and I'm not sure if it's needed at all, will investigate later
            # description
            # keywords
            # siteUrl
            # imageUrl
            # language
          }
        }
      }
    `
  );

  return siteMetadata;
};
